// Shared constants across the landing page

export const LOGO_URL = "/assets/logo_full.png";

// PMS System Screenshot
export const PMS_IMAGE = "/assets/pms.png";

// Images - 使用官網真實照片（皆已下載至本地 /assets/ 以避免外部 CDN 失效）
export const IMAGES = {
  // 首頁 Hero 使用天送幸福和苑
  hero: "/assets/tiansong.webp",
  // 真實案例照片 from lakeze.com
  tianSong: "/assets/tiansong.webp",
  senShan: "/assets/senshan.jpg",
  xingMeng: "/assets/xingmeng_new.webp",
  xingMeng2: "/assets/xingmeng2.jpg",
  // 哈庫納瑪塔塔（頂級非洲風包棟民宿）
  hakuna: "/assets/hakuna.webp",
  // 雲岫海景渡假會館（7 棟連棟大包棟）
  yunXiu: "/assets/yunxiu_lawn.webp",
  yunXiu2: "/assets/yunxiu.jpg",
  // 課程照片
  course: "/assets/course.png",
};

// LINE@ URL
export const LINE_URL = "https://line.me/R/oaMessage/@lakeze/?人客多一條龍營銷代管諮詢";

// 早鳥限量席次（改動下方兩個數字即可全站同步）
export const EARLYBIRD_TOTAL = 5;
export const EARLYBIRD_LEFT = 3;

// 輕量方案限量體驗席次（改動下方兩個數字即可同步）
export const LIGHT_TRIAL_TOTAL = 5;
export const LIGHT_TRIAL_LEFT = 3;
